import React from "react";
import JavascriptAjaxIntro from "./JavascriptAjaxIntro.jsx";
import JavascriptAjaxXmlhttp from "./JavascriptAjaxXmlhttp.jsx";
import JavascriptAjaxRequest from "./JavascriptAjaxRequest.jsx";
import JavascriptAjaxResponse from "./JavascriptAjaxResponse.jsx";
import JavascriptAjaxXmlFile from "./JavascriptAjaxXmlFile.jsx";
import JavascriptAjaxPhp from "./JavascriptAjaxPhp.jsx";
import JavascriptAjaxAsp from "./JavascriptAjaxAsp.jsx";
import JavascriptAjaxDatabase from "./JavascriptAjaxDatabase.jsx";
import JavascriptAjaxApplications from "./JavascriptAjaxApplications.jsx";
import JavascriptAjaxExamples from "./JavascriptAjaxExamples.jsx";

import JavascriptExamplesQuiz from "./JavascriptExamplesQuiz.jsx";
import JavascriptExamplesWebsite from "./JavascriptExamplesWebsite.jsx";
import JavascriptExamplesEditor from "./JavascriptExamplesEditor.jsx";
import JavascriptExamplesExercises from "./JavascriptExamplesExercises.jsx";
import JavascriptExamplesSyllabus from "./JavascriptExamplesSyllabus.jsx";
import JavascriptExamplesInterviewPrep from "./JavascriptExamplesInterviewPrep.jsx";
import JavascriptExamplesBootcamp from "./JavascriptExamplesBootcamp.jsx";
import JavascriptExamplesCertificate from "./JavascriptExamplesCertificate.jsx";

export default function JsAjax() {
  return (
    <div className="p-6 max-w-4xl mx-auto">
      <h1 className="text-3xl font-bold">JS AJAX</h1>
      <ul className="mt-4 list-disc ml-6">
        <li>
          <a href="/javascript/ajax/intro" className="underline">
            AJAX Intro
          </a>
        </li>
        <li>
          <a href="/javascript/ajax/xmlhttp" className="underline">
            AJAX XMLHttp
          </a>
        </li>
        <li>
          <a href="/javascript/ajax/request" className="underline">
            AJAX Request
          </a>
        </li>
        <li>
          <a href="/javascript/ajax/response" className="underline">
            AJAX Response
          </a>
        </li>
        <li>
          <a href="/javascript/ajax/xml-file" className="underline">
            AJAX XML File
          </a>
        </li>
        <li>
          <a href="/javascript/ajax/php" className="underline">
            AJAX PHP
          </a>
        </li>
        <li>
          <a href="/javascript/ajax/asp" className="underline">
            AJAX ASP
          </a>
        </li>
        <li>
          <a href="/javascript/ajax/database" className="underline">
            AJAX Database
          </a>
        </li>
        <li>
          <a href="/javascript/ajax/applications" className="underline">
            AJAX Applications
          </a>
        </li>
        <li>
          <a href="/javascript/ajax/examples" className="underline">
            AJAX Examples
          </a>
        </li>
        <li>
          <a href="/javascript/ajax/examples" className="underline">
            AJAX Examples
          </a>
        </li>
        <li>
          <a href="/javascript/examples/quiz" className="underline">
            JS Quiz
          </a>
        </li>
        <li>
          <a href="/javascript/examples/website" className="underline">
            JS Website
          </a>
        </li>
        <li>
          <a href="/javascript/examples/editor" className="underline">
            JS Editor
          </a>
        </li>
        <li>
          <a href="/javascript/examples/exercises" className="underline">
            JS Exercises
          </a>
        </li>
        <li>
          <a href="/javascript/examples/syllabus" className="underline">
            JS Syllabus
          </a>
        </li>
        <li>
          <a href="/javascript/examples/interview-prep" className="underline">
            JS Interview Prep
          </a>
        </li>
        <li>
          <a href="/javascript/examples/bootcamp" className="underline">
            JS Bootcamp
          </a>
        </li>
        <li>
          <a href="/javascript/examples/certificate" className="underline">
            JS Certificate
          </a>
        </li>
      </ul>
    </div>
  );
}
